import { collection, addDoc, updateDoc, deleteDoc, doc, getDocs, query, where, DocumentData } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { db, storage } from './firebase';
import { Project } from '../types/project';

const COLLECTION_NAME = 'projects';

type ProjectData = Omit<Project, 'id'>;

export const projectService = {
  // Get all projects
  async getAllProjects(): Promise<Project[]> {
    const querySnapshot = await getDocs(collection(db, COLLECTION_NAME));
    return querySnapshot.docs.map((doc) => {
      const data = doc.data() as ProjectData;
      return {
        id: doc.id,
        ...data,
      };
    });
  },

  // Get featured projects
  async getFeaturedProjects(): Promise<Project[]> {
    const q = query(collection(db, COLLECTION_NAME), where('featured', '==', true));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => {
      const data = doc.data() as ProjectData;
      return {
        id: doc.id,
        ...data,
      };
    });
  },

  // Add a new project
  async addProject(project: ProjectData): Promise<string> {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), project);
    return docRef.id;
  },

  // Update an existing project
  async updateProject(id: string, project: Partial<ProjectData>): Promise<void> {
    const projectRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(projectRef, project);
  },

  // Delete a project
  async deleteProject(id: string): Promise<void> {
    const projectRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(projectRef);
  },

  // Upload project images
  async uploadProjectImage(file: File, projectId: string): Promise<string> {
    const storageRef = ref(storage, `projects/${projectId}/${file.name}`);
    await uploadBytes(storageRef, file);
    return getDownloadURL(storageRef);
  },

  // Delete project image
  async deleteProjectImage(imageUrl: string): Promise<void> {
    const imageRef = ref(storage, imageUrl);
    await deleteObject(imageRef);
  },
}; 